import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const PublishIcon = ({ color = '#F1524B', size = '14', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.584 30.75c0 .69-.566 1.25-1.264 1.25H6.054C3.267 32 1 29.757 1 27V5c0-2.757 2.267-5 5.054-5H21.59c2.787 0 5.054 2.243 5.054 5v13.25c0 .69-.565 1.25-1.263 1.25s-1.264-.56-1.264-1.25V5c0-1.378-1.134-2.5-2.527-2.5H6.054C4.661 2.5 3.527 3.622 3.527 5v22c0 1.378 1.134 2.5 2.527 2.5h7.266c.698 0 1.264.56 1.264 1.25zm14.888-10.391a1.273 1.273 0 0 0-1.763.288l-6.229 8.607a.719.719 0 0 1-.497.244.718.718 0 0 1-.542-.191l-4.032-3.83a1.273 1.273 0 0 0-1.786.036 1.24 1.24 0 0 0 .036 1.767l4.036 3.834a3.278 3.278 0 0 0 2.456.879 3.268 3.268 0 0 0 2.36-1.25l6.253-8.64a1.241 1.241 0 0 0-.292-1.744zM20.326 7.5H7.311c-.698 0-1.263.56-1.263 1.25S6.613 10 7.31 10h13.015c.698 0 1.264-.56 1.264-1.25s-.566-1.25-1.264-1.25zm1.264 6.25c0-.69-.566-1.25-1.264-1.25H7.311c-.698 0-1.263.56-1.263 1.25S6.613 15 7.31 15h13.015c.698 0 1.264-.56 1.264-1.25zM7.311 17.5c-.698 0-1.263.56-1.263 1.25S6.613 20 7.31 20h7.905c.698 0 1.263-.56 1.263-1.25s-.565-1.25-1.263-1.25H7.31z"
      fill={color}
    />
  </svg>
);

PublishIcon.propTypes = propTypes;

export default PublishIcon;
